import { FC } from 'react';
import { Text } from '../Typography';

type SidebarButtonOwnProps = {
  header: string;
  title: string;
};

export type SidebarButtonProps = SidebarButtonOwnProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const SidebarButton: FC<SidebarButtonProps> = ({ header, title, ...props }) => {
  return (
    <div
      {...props}
      className="
        flex flex-col gap-1 p-4 rounded-md 
        bg-grey-light dark:bg-grey-light-dark 
        hover:bg-grey-plain hover:dark:bg-grey-plain-dark 
        w-full cursor-pointer"
    >
      <Text
        variant="text-sm-regular"
        className="text-grey-hover dark:text-grey-hover-dark truncate"
      >
        {header}
      </Text>
      <Text variant="text-xl-bold" className="text-grey-main dark:text-grey-main-dark truncate">
        {title}
      </Text>
    </div>
  );
};
